


import React from 'react';
import collageImage from '../img/banner/Frame 8 (3).png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers ,
  faPalette,
  faHandshake,
  faShieldHalved,
  faShieldAlt,
  faUserCheck,
} from '@fortawesome/free-solid-svg-icons';

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us-area">
       <div className='newwhy' style={{textAlign:"center",marginTop:'-32px'}}> 
        <h1 
                style={{ 
                  fontSize: "42px", 
                  fontFamily: "Lato, sans-serif", 
                  position: "relative", 
                  display: "inline-block",
                  color: "#ffbb60"
                }}
              >
                WhyChoose <span style={{ color: "#4b0100" }}>Us</span>
                <span
                  style={{
                    position: "absolute",
                    bottom: "-8px",
                    left: "79px",
                    width: "50%",
                    height: "2px",
                    backgroundColor: "#000",
                  }}
                />
              </h1>
        </div>
      <div className="container-fluid">
        <div className="row">
          {/* Image Section */}
          <div className="col-lg-5 col-md-12">
            <div className="why-choose-us-image">
              <img
                src={collageImage}
                alt="About Home"
                style={{ maxHeight: "578px", width: '100%', height: '747px' }}
              />
            </div>
          </div>

          {/* Content Section */}
          
          <div className="col-lg-7 col-md-12">
            
            <div className="why-choose-us-content">
              <div className="contents">
               
                <p style={{fontFamily:'Lato, sans-serif',textAlign:'',fontSize: '12px',textAlign:"left"}}>
  <span style={{ fontFamily: 'Lato, sans-serif', fontSize: '18px', }}>
   we go beyond providing just a place to stay-we deliver a complete 
  hospitality experience designed with care, comfort, and class. &nbsp;
  </span>

  <span style={{ fontFamily: 'Raqupine Regular', color: 'rgb(235, 195, 101)', fontSize: '18px' }}>
  Sharan’s Inn
  </span >  
  is the Right Choice for Your Journey.
</p>



                {/* Features List */}
                <ul className="features-list"style={{fontfamily: 'roboto'}} >
                  <li>
                    <div className="icon">
                    <FontAwesomeIcon icon={faUsers} />
                    </div>
                    <span style={{fontFamily:'roboto',color:'rgb(235, 195, 101)'}}>A Legacy of Warmth and Excellence
                    </span>
                    At Sharan’s Inn, we pride ourselves on delivering heartfelt hospitality that exceeds expectations. Every detail, from your welcome to your departure, is crafted to make your stay unforgettable. 
                  </li>

                  <li >
                    <div className="icon">
                      <FontAwesomeIcon icon={faHandshake} />
                    </div>
                    <span style={{fontFamily:'roboto',color:'rgb(235, 195, 101)'}}>Tailored for Every Guest</span>
                    Whether you're a solo traveler, family on vacation, or planning a large event, our spaces and services are thoughtfully curated to meet diverse needs with style and comfort. 
                  </li>

                  <li>
                    <div className="icon">
                      <FontAwesomeIcon icon={faHandshake} />
                    </div>
                    <span style={{fontFamily:'roboto',color:'rgb(235, 195, 101)'}}>Unmatched Quality & Cleanliness</span>
                    ThWe uphold the highest standards of hygiene and quality across our rooms, dining, and event services—ensuring peace of mind and a premium experience.
                  </li>

                  <li>
                    <div className="icon">
                    <FontAwesomeIcon icon={faShieldHalved} />
                    </div>
                    <span style={{fontFamily:'roboto',color:'rgb(235, 195, 101)'}}> Dedicated Support, Always</span>
                    Our staff isn’t just professional—they’re passionate. From check-in to check-out, you’ll feel the warmth and attentiveness that makes Sharan’s Inn stand out. 
                  </li>

                  <li>
                    <div className="icon">
                      <FontAwesomeIcon icon={faShieldAlt} />
                    </div>
                    <span style={{fontFamily:'roboto',color:'rgb(235, 195, 101)'}}>Where Every Stay Feels Like Home</span>
                    We believe in more than just providing a room; we create a space where guests feel at ease, valued, and always welcome.
                  </li>

                  <li>
                    <div className="icon">
                      <FontAwesomeIcon icon={faUserCheck} />
                    </div>
                    <span style={{fontFamily:'roboto',color:'rgb(235, 195, 101)'}}>Strategic Location</span>
                    Conveniently located for both business and leisure travellers, Sharan’s Inn offers easy access to key destinations in the city. 
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;



// import React, { useState } from "react";
// import carImage from "../img/banner/abouthome.jpg";

// const WhyChooseUs = () => {
//   const [showForm, setShowForm] = useState(false);

//   const containerStyle = {
//     fontFamily: "Arial, sans-serif",
//     padding: "40px 20px",
//     backgroundColor: "#4b0100",
//     color: "white",
//   };

//   const headingStyle = {
//     fontSize: "32px",
//     fontWeight: "bold",
//     marginBottom: "10px",
//     textAlign: "center",
//   };

//   const contentWrapper = {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "40px",
//     maxWidth: "1200px",
//     margin: "0 auto",
//   };

//   const leftImageContainer = {
//     flex: "1",
//     minWidth: "300px",
//   };

//   const imageStyle = {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     borderRadius: "10px",
//     border: "10px solid #fff",
//     boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
//   };

//   const rightContent = {
//     flex: "2",
//     display: "flex",
//     flexDirection: "column",
//     gap: "20px",
//     flexWrap: "wrap",
//   };

//   const featuresGrid = {
//     display: "grid",
//     gridTemplateColumns: "repeat(3, 1fr)",
//     gap: "20px",
//   };

//   const featureCard = {
//     backgroundColor: "rgba(255,255,255,0.1)",
//     padding: "20px",
//     borderRadius: "10px",
//     textAlign: "center",
//     color: "white",
//   };

//   const buttonStyle = {
//     marginTop: "30px",
//     padding: "12px 24px",
//     backgroundColor: "white",
//     color: "red",
//     border: "none",
//     borderRadius: "8px",
//     fontWeight: "bold",
//     fontSize: "16px",
//     cursor: "pointer",
//     alignSelf: "center",
//   };

//   const popupOverlay = {
//     position: "fixed",
//     top: 0,
//     left: 0,
//     right: 0,
//     bottom: 0,
//     backgroundColor: "rgba(0,0,0,0.6)",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     zIndex: 999,
//   };

//   const popupForm = {
//     backgroundColor: "#fff",
//     padding: "30px",
//     borderRadius: "12px",
//     width: "90%",
//     maxWidth: "400px",
//     color: "red",
//     animation: "popupFade 0.5s ease",
//   };

//   const inputStyle = {
//     width: "100%",
//     padding: "10px",
//     marginBottom: "15px",
//     borderRadius: "6px",
//     border: "1px solid red",
//   };

//   const closeBtn = {
//     position: "absolute",
//     top: "20px",
//     right: "30px",
//     fontSize: "30px",
//     color: "white",
//     cursor: "pointer",
//   };

//   return (
//     <div style={containerStyle}>
//       <h2 style={headingStyle}>Why choose <em>us?</em></h2>
//       <div style={contentWrapper}>
//         {/* Left Image */}
//         <div style={leftImageContainer}>
//           <img src={carImage} alt="Hotel" style={imageStyle} />
//         </div>

//         {/* Right Content */}
//         <div style={rightContent}>
//           <div style={featuresGrid}>
//             {[
//               { icon: "🔧", title: "Comprehensive Hospitality Under One Roof" },
//               { icon: "🔁", title: "Fast Turnaround" },
//               { icon: "💰", title: "Affordable Pricing" },
//               { icon: "🧰", title: "All-Inclusive Services" },
//               { icon: "🚗", title: "Reliable Service" },
//               { icon: "🌟", title: "Top Ratings" },
//             ].map((item, idx) => (
//               <div key={idx} style={featureCard}>
//                 <div style={{ fontSize: "28px", marginBottom: "10px" }}>{item.icon}</div>
//                 <div style={{ fontWeight: "bold", fontSize: "16px" }}>{item.title}</div>
//               </div>
//             ))}
//           </div>
//           <button style={buttonStyle} onClick={() => setShowForm(true)}>Get a FREE quote</button>
//         </div>
//       </div>

//       {/* Smooth Popup Form */}
//       {showForm && (
//         <div style={popupOverlay}>
//           <div style={popupForm}>
//             <h3 style={{ textAlign: "center", marginBottom: "20px" }}>Hotel Booking Form</h3>
//             <input type="text" placeholder="Name" style={inputStyle} />
//             <input type="email" placeholder="Email" style={inputStyle} />
//             <input type="tel" placeholder="Mobile Number" style={inputStyle} />
//             <button style={{ ...inputStyle, backgroundColor: "red", color: "white", border: "none" }}>Submit</button>
//           </div>
//           <div style={closeBtn} onClick={() => setShowForm(false)}>×</div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default WhyChooseUs;
